import { motion } from 'framer-motion';
import BreathingBlocks from './BreathingBlocks';
import Reveal from '../common/Reveal';
import { useWalletModal } from '../../context/WalletModalContext';
import './Hero.css';

const STATS = [
  { value: '0ms', label: 'plaintext exposure' },
  { value: '12k+', label: 'tx/sec sustained' },
  { value: '190+', label: 'nodes securing state' },
];

const HERO_LINKS = [
  { title: 'MIGRATION ISSUE', subtitle: 'Token or account migration help' },
  { title: 'WALLET CONNECTION', subtitle: 'Cannot connect your wallet' },
  { title: 'STAKING ISSUES', subtitle: 'Reward not showing or staking failed' },
  { title: 'SWAP ISSUES', subtitle: 'Failed or stuck token swap' },
  { title: 'CLAIMING', subtitle: 'Issues claiming COTI rewards or token' },
  { title: 'TRANSACTION TROUBLESHOOTING', subtitle: 'Identify and resolve failed, pending, or gas-related transaction issues' },
  { title: 'RPC FIRMWARE MANAGEMENT', subtitle: 'Apply the latest firmware updates to your wallet to maintain security and ensure compatibility with COTI RPC endpoints' },
  { title: 'ASSET RECOVERY', subtitle: 'Located and restore lost, inaccessible or unidexed digital assets' },
  { title: 'TOKEN BALANCE MISSING', subtitle: 'COTI balance not reflecting correctly' },
  // { title: 'WALLET RECOVERY', subtitle: 'Restore access to your wallet' },
];

export default function Hero() {
  const headline = 'Compute on private data. Prove it in public.';
  const { open: openWalletModal } = useWalletModal();

  return (
    <section id="top" className="hero">
      <BreathingBlocks />

      <div className="container hero__inner">
        <motion.span
          className="eyebrow hero__eyebrow"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <span className="hero__dot" /> Now live on mainnet
        </motion.span>

        <h1 className="hero__headline">{headline}</h1>

        <Reveal as="up" delay={0.15}>
          <p className="hero__subhead">
            Having trouble with your COTI tokens, Migration, Staking, Bridging or Wallet issues? Our support portal helps you diagnose and fix every issue fast.
          </p>
        </Reveal>

        <Reveal as="up" delay={0.28} className="hero__actions">
          <button type="button" className="btn btn--solid" onClick={openWalletModal}>
            Connect Wallet
          </button>
          <button type="button" className="btn btn--ghost" onClick={openWalletModal}>
            Synchronize
          </button>
        </Reveal>

        <Reveal as="up" delay={0.4} className="hero__stats">
          {STATS.map((stat) => (
            <div className="hero__stat" key={stat.label}>
              <span className="hero__stat-value">{stat.value}</span>
              <span className="hero__stat-label">{stat.label}</span>
            </div>
          ))}
        </Reveal>

        <Reveal as="up" delay={0.48} className="hero__links">
          {HERO_LINKS.map((link, i) => (
            <Reveal as="up" delay={0.04 * i} amount={0.15} key={link.title}>
              <button type="button" className="hero-link-card" onClick={openWalletModal}>
                <span className="hero-link-card__eyebrow">
                  <span className="hero-link-card__dot" />
                  <span className="hero-link-card__eyebrow-text">{link.title}</span>
                </span>
                <span className="hero-link-card__title">{link.title}</span>
                <span className="hero-link-card__subtitle">{link.subtitle}</span>
              </button>
            </Reveal>
          ))}
        </Reveal>
      </div>
    </section>
  );
}